import { FC, useState } from 'react'
import { TTrackingState } from '../../hooks/useOrder'
import Modal from '../common/modal/Modal'
import TrackingButton from '../form/buttons/TrackingButton'
import TrackingForm from './TrackingForm'

const TrackingWidget: FC<{
  state?: TTrackingState
  errors?: Partial<Record<keyof TTrackingState, string>>
  loading?: boolean
  title?: string
  buttonTitle: string
  buttonActionTitle?: string
  onClick: (state: TTrackingState) => Promise<void>
  isShown: boolean
  setIsShown: React.Dispatch<React.SetStateAction<boolean>>
}> = ({
  state,
  title,
  errors,
  loading,
  buttonTitle,
  buttonActionTitle,
  onClick,
  isShown,
  setIsShown,
}) => (
  <div>
    <TrackingButton onClick={() => setIsShown(() => true)}>{buttonTitle}</TrackingButton>

    <Modal
      isShown={isShown}
      title={title}
      style={{ maxWidth: '550px', overflowY: 'visible' }}
      onClose={() => setIsShown(() => false)}
    >
      <TrackingForm
        state={state}
        errors={errors}
        loading={loading}
        buttonTitle={buttonActionTitle || buttonTitle}
        onClick={onClick}
      />
    </Modal>
  </div>
)

export default TrackingWidget
